import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerOrders_remittanceOrders_edges_node_remittanceLine_remittance } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import { RemittanceRunnerRemittances_remittances_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerRemittances";
import React from "react";

import RemittanceRunnerAgingBadge from "../RemittanceRunnerAgingBadge";

interface RemittanceRunnerTblColAgingProp {
  remittance:
    | RemittanceRunnerRemittances_remittances_edges_node
    | RemittanceRunnerOrders_remittanceOrders_edges_node_remittanceLine_remittance;
}

export const RemittanceRunnerTblColAging: React.FC<RemittanceRunnerTblColAgingProp> = props => {
  const { remittance } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Aging</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => remittance?.aging) ? (
          <RemittanceRunnerAgingBadge
            aging={remittance?.aging}
            status={remittance?.status}
          />
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColAging;
